import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

type Props = {
  mTop?: number;
};

export const AttestationEntry = styled.div<Props>`
  padding-left: 8px;
  word-wrap: break-word;
  white-space: pre-line;
  margin-top: ${({ mTop }) => mTop || 0}px;
`;

export const TextWrap = styled(Text14)`
  word-break: break-all;
`;
